import React from 'react';
import { Typography } from '@getgo/chameleon-web/react';
import i18n from '../i18n';

export const dateFormatted = (days: string, hours: string, minutes: string) => {
  const Days =
    days === '0' ? undefined : (
      <div className="event-remaining-time-box">
        <Typography variant="heading-medium" color="text-01">
          {days}
        </Typography>
        <span className="event-time-name-spacing">{i18n.t('event.registration.days')}</span>
      </div>
    );
  const Hours =
    Days && hours === '0' ? undefined : (
      <div className="event-remaining-time-box">
        <Typography variant="heading-medium" color="text-01">
          {hours}
        </Typography>
        <span className="event-time-name-spacing">{i18n.t('event.registration.hours')}</span>
      </div>
    );
  const Minutes =
    Days && Hours && minutes === '0' ? (
      ''
    ) : (
      <div className="event-remaining-time-box">
        <Typography variant="heading-medium" color="text-01">
          {minutes}
        </Typography>
        <span className="event-time-name-spacing">{i18n.t('event.registration.minutes')}</span>
      </div>
    );
  return (
    <>
      {Days}
      {Hours}
      {Minutes}
    </>
  );
};

export const welcomeMessage = (firstName: string, lastName: string) => {
  const welcomeTxt = i18n.t('event.registration.welcome');
  if (firstName?.length === 0) {
    return `${welcomeTxt}!`;
  }
  if (firstName?.length === 1 || (firstName?.length <= 2 && firstName.charAt(1) === '.')) {
    return `${welcomeTxt} ${firstName} ${lastName}!`;
  }
  return `${welcomeTxt} ${firstName}!`;
};
